/*
 * Order source tracking (CC-TODAY 168a, Oct 31). Where did this buyer come from?
 *
 * On every page view: if the visit brings a NEW source (utm_source in the link,
 * a Google/Pinterest/... click id, or a link from another website), it becomes the
 * "last" touch; the very first one ever is kept as the "first" touch. A plain click
 * inside the shop (or typing the address) never overwrites a known source with "direct".
 * Kept 90 days. paddle-checkout.js sends both to Paddle (custom_data.source) and the
 * Worker writes them onto the Shopify order (note attributes + tag src:<last>).
 *
 * Privacy: first-party only, nothing is sent anywhere until the buyer pays. The 90-day
 * copy (localStorage) is kept only when Shopify's cookie banner allows analytics (or
 * no banner applies); until then it lives in this tab only (sessionStorage) and is
 * still attached to an order placed in that visit. Nothing visible changes for buyers.
 * Early-access tokens and other query values are never stored: landing = path + utm only.
 */
(function () {
  var KEY = 'lk-src';
  var DAYS = 90;
  var MS = DAYS * 24 * 60 * 60 * 1000;
  var OWN = /(^|\.)(litelierdesigns\.com|myshopify\.com|shopify\.com|shop\.app|paddle\.com)$/i;
  var EMAIL_HOSTS = /^(mail\.google\.com|outlook\.live\.com|outlook\.office\.com|outlook\.office365\.com|mail\.yahoo\.com|mail\.aol\.com|webmail\..*|mail\..*)$/i;

  function cut(v, n) {
    return String(v || '').replace(/[\u0000-\u001f]/g, ' ').trim().slice(0, n);
  }

  /** One simple name per source (used for the tag src:<name>). */
  function classify(utmSource, utmMedium, refHost, params) {
    var s = (utmSource || '').toLowerCase();
    var m = (utmMedium || '').toLowerCase();
    if (s) {
      if (/pinterest|^pin$/.test(s)) return 'pinterest';
      if (/systeme|newsletter|^email$|^mail/.test(s) || /e-?mail|newsletter/.test(m)) return 'email';
      if (/google/.test(s)) return 'google';
      if (/etsy/.test(s)) return 'etsy';
      if (/^(ig|insta)|instagram/.test(s)) return 'instagram';
      if (/^fb$|facebook|^meta$/.test(s)) return 'facebook';
      var clean = s.replace(/[^a-z0-9.-]/g, '').slice(0, 30);
      return clean || 'other';
    }
    if (params.get('epik')) return 'pinterest';
    if (params.get('gclid') || params.get('gbraid') || params.get('wbraid')) return 'google';
    if (params.get('fbclid')) return 'facebook';
    if (!refHost) return 'direct';
    var h = refHost.toLowerCase().replace(/^www\./, '');
    if (EMAIL_HOSTS.test(h)) return 'email';
    if (/(^|\.)pinterest\.[a-z.]+$|^pin\.it$/.test(h)) return 'pinterest';
    if (/(^|\.)google\.[a-z.]+$/.test(h)) return 'google';
    if (/(^|\.)etsy\.(com|me)$|^etsy\.[a-z.]+$/.test(h)) return 'etsy';
    if (/(^|\.)instagram\.com$/.test(h)) return 'instagram';
    if (/(^|\.)(facebook\.com|fb\.com|fb\.me|messenger\.com)$/.test(h)) return 'facebook';
    if (/(^|\.)systeme\.io$/.test(h)) return 'systeme';
    return h.slice(0, 30);
  }

  function landingNow(params) {
    var keep = [];
    ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function (k) {
      var v = params.get(k);
      if (v) keep.push(k + '=' + encodeURIComponent(cut(v, 60)));
    });
    return cut(location.pathname + (keep.length ? '?' + keep.join('&') : ''), 200);
  }

  function touchFromThisPage() {
    var params = new URLSearchParams(location.search);
    var refHost = '';
    var refShort = '';
    try {
      if (document.referrer) {
        var r = new URL(document.referrer);
        if (!OWN.test(r.hostname) && r.hostname !== location.hostname) {
          refHost = r.hostname;
          refShort = cut(r.hostname + r.pathname, 200); // no query: search words / tokens stay out
        }
      }
    } catch (e) {}
    var us = cut(params.get('utm_source'), 80);
    var um = cut(params.get('utm_medium'), 80);
    var uc = cut(params.get('utm_campaign'), 100);
    var hasClickId = params.get('gclid') || params.get('gbraid') || params.get('wbraid') || params.get('fbclid') || params.get('epik');
    var isNew = Boolean(us || refHost || hasClickId);
    var t = { src: classify(us, um, refHost, params), landing: landingNow(params), at: new Date().toISOString() };
    if (us) t.utm_source = us;
    if (um) t.utm_medium = um;
    if (uc) t.utm_campaign = uc;
    if (refShort) t.referrer = refShort;
    return { touch: t, isNew: isNew };
  }

  function fresh(t, now) {
    return t && t.at && now - Date.parse(t.at) < MS ? t : null;
  }

  function read(store) {
    try {
      var v = JSON.parse(window[store].getItem(KEY) || 'null');
      return v && typeof v === 'object' ? v : null;
    } catch (e) {
      return null;
    }
  }

  function write(store, v) {
    try {
      window[store].setItem(KEY, JSON.stringify(v));
    } catch (e) {}
  }

  /** null = not known yet (banner API not loaded), true/false = Shopify's answer. */
  function analyticsAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return Boolean(cp.analyticsProcessingAllowed());
    } catch (e) {}
    return null;
  }

  function persist() {
    var state = read('sessionStorage');
    if (!state) return;
    var ok = analyticsAllowed();
    if (ok === true) write('localStorage', state);
    else if (ok === false) {
      try {
        window.localStorage.removeItem(KEY);
      } catch (e) {}
    }
  }

  var now = Date.now();
  var saved = read('sessionStorage') || read('localStorage') || {};
  var first = fresh(saved.first, now);
  var last = fresh(saved.last, now);
  var here = touchFromThisPage();
  if (!first) first = here.touch;
  if (here.isNew || !last) last = here.touch;
  write('sessionStorage', { first: first, last: last });
  persist();

  // Ask Shopify for the visitor's cookie answer, then keep (or drop) the 90-day copy.
  try {
    if (!(window.Shopify && window.Shopify.customerPrivacy) && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (!err) persist();
      });
    }
  } catch (e) {}
  document.addEventListener('visitorConsentCollected', persist);

  /** For paddle-checkout.js: { first, last } with empty values left out, or null. */
  window.__litelierSource = function () {
    var v = read('sessionStorage') || read('localStorage');
    return v && v.first ? { first: v.first, last: v.last || v.first } : null;
  };
})();
